CCL.hideCutoffNotification = {
  autoload: [
    ['hideCutoffNotification', $('.c-alert-banner-cut-off-notification').length > 0]
  ],

  hideCutoffNotification() {
    $('.close-notification').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        const targetElement = $(event.target).parents('.c-alert-banner-cut-off-notification');
        $(targetElement).removeClass('show');
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-alert-banner-cut-off-notification/alert-banner-cut-off-notification.js